export default __webpack_public_path__ + "static/media/Approvals.10722c02.jpg";